module.exports = __webpack_public_path__ + "img/instagramestory4-1.f2fb1012.jpg";